<script>
  /**
   * @deprecated This component is replaced by project-based navigation (ProjectsList + ProjectEventsView)
   * Keep for emergency rollback only - can be removed after successful testing
   * To rollback: set useProjectNavigation() to return false in TicketsApp.vue
   */
  import { CalendarIcon, ChevronRightIcon } from '@heroicons/vue/solid';
  import { isNotSoldOut, saleOpen } from '@/composables/useEvent';
  import { formatDate, formatTime } from '@/utils/date';
  import InfoPopup from '@/components/InfoPopup.vue';
  import TicketsAvailableBanner from '@/components/events/TicketsAvailableBanner.vue';
  export default {
    name: 'Events',
    components: {
      TicketsAvailableBanner,
      CalendarIcon,
      ChevronRightIcon,
      InfoPopup,
    },
    props: {
      events: {
        type: Array,
        default: () => [],
      },
    },
    emits: ['selectEvent'],
    setup() {
      return {
        isNotSoldOut,
        saleOpen,
        formatTime,
        formatDate,
      };
    },
    methods: {
      selectEvent(event) {
        if (this.isNotSoldOut(event) && this.saleOpen(event)) {
          this.$emit('selectEvent', event);
        }
      },
    },
  };
</script>

<template>
  <div class="overflow-hidden bg-white shadow sm:rounded-md">
    <!-- Empty State -->
    <div v-if="events.length === 0" class="px-4 py-12 text-center">
      <p class="text-gray-500">{{ $t('tickets.empty_state') }}</p>
    </div>

    <!-- Events List -->
    <ul v-else role="list" class="divide-y divide-gray-200">
      <li v-for="event in events" :key="event.id">
        <div
          class="block hover:bg-gray-50"
          :class="{ 'cursor-pointer': saleOpen(event) }"
          @click="selectEvent(event)"
        >
          <div class="flex items-center px-4 py-4 sm:px-6">
            <div
              class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between"
            >
              <div class="truncate">
                <div class="text-sm sm:flex sm:gap-1">
                  <p class="text-primary-600 truncate font-medium">
                    {{ event.title }}
                  </p>
                  <p class="shrink-0 font-normal text-gray-500 sm:ml-1">
                    in {{ event.location.name }}
                  </p>
                </div>
                <div class="mt-2 sm:flex sm:items-center">
                  <div v-if="event.description !== ''" class="mr-4">
                    <InfoPopup
                      :content="event.description"
                      :title="event.title"
                      label="meer info"
                    />
                  </div>
                  <div
                    class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0"
                  >
                    <CalendarIcon
                      class="mr-1.5 h-5 w-5 shrink-0 text-gray-400"
                      aria-hidden="true"
                    />
                    <div>
                      {{ formatDate(event.date, 'DD-MM-YYYY') }}
                      <span>
                        | {{ formatTime(event.start_time) }} -
                        {{ formatTime(event.end_time) }}
                      </span>
                    </div>
                  </div>
                  <TicketsAvailableBanner class="ml-8" :event />
                </div>
              </div>
              <div class="mt-4 shrink-0 sm:ml-5 sm:mt-0">
                <div class="flex -space-x-1 overflow-hidden"></div>
              </div>
            </div>
            <div
              v-if="isNotSoldOut(event) && saleOpen(event)"
              class="ml-5 shrink-0"
            >
              <ChevronRightIcon
                class="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
